export default import.meta.ROLLDOWN_FILE_URL_TcR4nbv8RW7Jccr5IGhTTg